// extracted by css-extract-rspack-plugin
export default {"section":"src-components-network-ConnectionInputForm-module__section-CruX_p","connectionInputGroup":"src-components-network-ConnectionInputForm-module__connectionInputGroup-FE1NWJ","disabledMessage":"src-components-network-ConnectionInputForm-module__disabledMessage-sHJv1x","connectionMessage":"src-components-network-ConnectionInputForm-module__connectionMessage-UKzfqR"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"section\":\"src-components-network-ConnectionInputForm-module__section-CruX_p\",\"connectionInputGroup\":\"src-components-network-ConnectionInputForm-module__connectionInputGroup-FE1NWJ\",\"disabledMessage\":\"src-components-network-ConnectionInputForm-module__disabledMessage-sHJv1x\",\"connectionMessage\":\"src-components-network-ConnectionInputForm-module__connectionMessage-UKzfqR\"}";
        // 1793732343912
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  